// extracted by mini-css-extract-plugin
export default {"modalContent":"DisableAccount_modalContent__GeCdB","footerBtns":"DisableAccount_footerBtns__KlAzP","mb24":"DisableAccount_mb24__62crX","modal":"DisableAccount_modal__CrPKX"};